import { render, staticRenderFns } from "./LogisticsLog.vue?vue&type=template&id=481c78a4"
import script from "./LogisticsLog.vue?vue&type=script&lang=js"
export * from "./LogisticsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports